export { default } from './CssBaseline';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/CssBaseline/index.js
// module id = 449
// module chunks = 121